import React from 'react';
import SummarySection from '../components/organisms/summarySection';
import ComplaintManagementDetails from './ComplaintManagementDetails';
import '../styles/complaintmanagement.css';

const ShowTablePage = () => {
  return (
    <main className="ca-query-management-page">
      <SummarySection />
      <ComplaintManagementDetails />
    </main>
  );
};

export default ShowTablePage;